import { useContentfulGetById } from '../../../hooks/useContentfulGetById'
import Heading from '../../Heading/Heading'
import Text from '../../Text/Text'

const ClientProject = (id) => {
  var data = id.id

  var { contentfulData: projects } = useContentfulGetById(data)
  if (projects.length === 0) {
    return null
  } else {
    var project = projects.items[0].fields
    return (
      <div>
        <Heading type="h5" headingSize="h6" className="client-card-overview">
          Overview
        </Heading>
        <div className="project-info">
          <Text>ANDis:</Text>
          <Text className="project-info-data">{project.numberOfAndIs}</Text>
          <Text>SDM/SDL:</Text>
          <Text className="project-info-data">{project.sdmsdl}</Text>
          <Text>Project Lead:</Text>
          <Text className="project-info-data">{project.projectLead}</Text>
        </div>
        <Text className="project-info-data">{project.overview}</Text>
      </div>
    )
  }
}
export default ClientProject
